<template lang='pug'>
  v-container.pa-0(fill-height='', fluid='', grid-list-xl='')
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    v-dialog( persistent  :value='showBillDialog'  max-width='600px'   transition="dialog-bottom-transition")
      div(style ='position:relative; height: 100%;')
        bill-preview(@close='showBillDialog=false' @showSupportImage='showSupportImage' @showProduct='productDialog=true' :item="currentTransaction" :currentType='currentType' )
    v-dialog( persistent  :value='purchaseDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      PurchaseForm(v-if='purchaseDialog' @close="purchaseDialog = false")
    v-dialog( persistent  :value='transferDialog'  max-width='800px'   transition="dialog-bottom-transition" )
      TransferForm(v-if='transferDialog' @close="transferDialog = false")
    v-dialog( :fullscreen = 'isMobile' persistent :key='currentItem.name' :value='productDialog'  max-width='800px'   transition="dialog-bottom-transition")
      Preview(v-if='productDialog' :model ='currentItem' @close='productDialog=false')
    v-layout(wrap='')
      v-flex(md12='')
        v-btn(color="#009da5" fab small dark="" v-if="isMobile" @click="$router.go(-1)").mt-2.ml-5
          v-icon(size="25") mdi-arrow-left
        base-material-card( icon='mdi-earth' :title="$t('requests.title')")
          .text-center(style="display:flex; align-items:flex-start;").mt-2
            v-menu(v-model='menu', :close-on-content-click='false', :nudge-width='200', nudge-top offset-x='')
              template(v-slot:activator='{ on }')
                v-btn(color='#3cbbc2', dark='', v-on='on' style="height: 48px;").mt-0
                  v-icon mdi-calendar
                  | {{$t('requests.dates')}}

              v-card(style="border:3px solid #3cbbc2;").pa-2
                date-filter(@closeMenu="menu = false" :currentType= 'currentType',)
            <!--.text-center(style="display:flex; align-items:center;")-->
              <!--v-select.elevation-0(-->
              <!--label='Filtrar por tienda',-->
              <!--:items='field.locations || []',-->
              <!--v-model='currentLocation',-->
              <!--item-text='full_name',-->
              <!--return-object, dense='', solo='',-->
              <!--clearable='', @input='selectShop',-->
              <!--@click:clear='clearShopSelection')-->
                <!--template(v-if='data.item' slot='selection', slot-scope='data')-->
                  <!--v-flex(xs2='')-->
                    <!--v-avatar(size='25px')-->
                      <!--img( v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')-->
                  <!--v-flex.ml-1(style='font-size:10px; color :#000;')-->
                    <!--| {{ data.item.name }}-->
                <!--template(v-if='data.item' slot='item', slot-scope='data' )-->
                  <!--v-row-->
                    <!--v-avatar-->
                      <!--img(v-if='!!data.item' width='25' style='object-fit:cover;' :src='data.item.pictures.imageInput1')-->
                    <!--b {{data.item.name}}-->
          // cards
          template(v-if="!isMobile")
            v-layout.bill-action__button-row().my-2
            v-flex(style='display:flex; flex-direction: row; flex-wrap: wrap; justify-content:flex-start; align-items:center;')
              v-flex(sm6='', xs12='', md6='', lg3='')
                base-material-stats-card( v-if ='!!transactions'  color='warning', icon='mdi-pound', small-value='#' :title="$t('requests.movements')", :value='transactions.length.toString()')
              <!--v-flex(sm6='', xs12='', md6='', lg3='')-->
                <!--base-material-stats-card( color='cyan', icon='mdi-coin', small-value='$' title='Total', :value=' transactionTotals.total.toFixed(0) | numberFormat()')-->
              <!--v-flex(sm6='', xs12='', md6='', lg3='')-->
                <!--base-material-stats-card( color='#008E95', icon='mdi-coin', small-value='$' title='Utilidad', :value=' transactionTotals.revenue.toFixed(0) | numberFormat()')-->
          template(v-else)
            v-row.px-2
              v-col(cols="12")
                mobileCard(v-if ='!!transactions'  color='warning', icon='mdi-pound', valueIcon='#' :title="$t('requests.movements')", :value='transactions.length.toString()')
          template()
            v-card
              v-card-title
                v-text-field(v-model='search',@input='setSearchCriteria' append-outer-icon='mdi-search', :label="$t('requests.search')", single-line='', hide-details='')

              v-data-table.elevation-1(:headers="headers" :items="transactions || []"  item-key="name" )
                template(v-slot:top="")
                  v-toolbar(flat="" color="white")
                    v-toolbar-title {{$t('requests.title_table')}}
                    .flex-grow-1
                template( v-slot:item="props" )
                  tr(style="cursor: pointer;")
                    td.text-xs-left(@click="showBill(props.item)")
                      .datatable-cell-wrapper {{ props.item.reference_number }}
                    td.text-xs-left(hidden @click="showBill(props.item)")
                      | {{props.item.items}}
                    td.text-xs-left(style="max-width:250px;" @click="showBill(props.item)")
                      span(v-for='product in props.item.items').mr-1
                        | {{product.name}},
                    td.text-xs-left(@click="showBill(props.item)")
                      .datatable-cell-wrapper  {{ props.item.time | moment("h:mm:ss a, dddd, MMMM Do YYYY") }}
                    td.text-xs-left(@click="showBill(props.item)")
                      .datatable-cell-wrapper {{props.item.location_from ? props.item.location_from.name : ''}}
                    td.text-xs-left(@click="showBill(props.item)")
                      .datatable-cell-wrapper {{ props.item.location_to ? props.item.location_to.name : ''}}
                    td.text-xs-left(v-if="props.item.type !=='transfers'" @click="showBill(props.item)")
                      .datatable-cell-wrapper {{ props.item.total | numberFormat}}
                    td.text-xs-left(v-if="props.item.type !=='transfers'" @click="showBill(props.item)")
                      .datatable-cell-wrapper {{ props.item.status}}
                    td.text-xs-center
                      v-btn(@click="cancelRequest(props.item)" color="red" text='' :disabled="!(props.item.status != 'canceled' && props.item.status != 'completed')")
                        | CANCELAR
</template>

<script>
  import DateFilter from '@/components/custom/filters/DateFilter'
  import PurchaseForm from '@/components/custom/forms/PurchaseForm'
  import TransferForm from '@/components/custom/forms/TransferForm'
  import Preview from '@/components/custom/preview/ProductPreview'
  import BillPreview from '@/components/custom/preview/transactions/RequestBillPreview'
  import loaders from '@/plugins/mixins/loaders'
  export default {
    components: {
      BillPreview: BillPreview,
      Preview: Preview,
      PurchaseForm: PurchaseForm,
      TransferForm: TransferForm,
      DateFilter: DateFilter,
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
    },
    filters: {
      numberFormat (val) {
        if (val) { return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
    },
    mixins: [loaders],
    data () {
      return {
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        itemsState: [
          'pending',
          'cancel',
        ],
        menu: false,
        currentLocation: null,
        select: {},
        currentTransaction: null,
        purchaseDialog: false,
        transferDialog: false,
        showBillDialog: false,
        search: '',
        currentType: '',
        createItemDialog: false,
        productDialog: false,
        headers: [
          {
            sortable: false,
            text: this.$t('requests.table_headers.reference_number'),
            value: 'type',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('requests.table_headers.products'),
            value: 'items',
            align: 'left',
          },
          {
            sortable: true,
            text: this.$t('requests.table_headers.time'),
            value: 'time',
            align: 'left',

          },
          {
            sortable: false,
            text: this.$t('requests.table_headers.location'),
            value: 'location_from',
            align: 'left',

          },
          {
            sortable: true,
            text: this.$t('requests.table_headers.total'),
            value: 'total',
            align: 'left',

          },
          {
            text: '',
            value: 'data-table-expand',
          },
          {
            text: this.$t('requests.table_headers.state'),
            value: 'data-table-expand',
          },
          {
            text: this.$t('requests.table_headers.actions'),
            value: 'actions',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      field () {
        return {
          locations: this.$store.getters['shops/getItems'],
          categories: this.$store.getters['categories/getItems'],
        }
      },
      revenue () {
        return this.$store.getters['transactions/getRevenueTotal']
      },
      currentItem () {
        return this.$store.getters['products/getCurrentItem']
      },

      products () {
        return [
          {
            name: 'Todos',
            value: '',
          },
        ]
      },
      requests () {
        const arrResponse = this.$store.state.transactions.requests
        return arrResponse
      },
      // FILTRO DE TRANSACCIONES NO ESTA FUNCIONANDO CORRECTAMENTE, NO ACTUALIZA LOS DATOS DEPENDIENDO DE LA TIENDA
      transactions () {
        const vm = this
        let arrResponse = []
        if (!!vm.currentLocation && !!vm.requests) {
          // console.log('se escogio : ' + vm.currentLocation.name)
          arrResponse = vm.requests.filter((el) => {
            if (el.location_from.id === vm.currentLocation.id) {
              // console.log(el.location_from.id, vm.currentLocation.id)
              return true
            }
          })
        } else {
          // console.log('entra en nulo')
          arrResponse = vm.requests
        }
        return arrResponse
      },
      transactionTotals () {
        const vm = this
        let total = 0
        let revenue = 0
        // console.log(revenue)
        if (vm.transactions) {
          const list = vm.transactions || {}
          list.forEach(element => {
            // if( Vue.moment().isSame(element.time, state.currentDateFilter))
            total += +element.total
            if (element.items) {
              element.items.forEach(item => {
                if (item.purchase) {
                  revenue += (+item.price - +item.purchase) * +item.amount
                }
              })
            }
          })
          return {
            total: total,
            revenue: revenue,
          }
        }
        return {
          total: 0,
          revenue: 0,
        }
      },
    },
    watch: {
      transactions (val, oldval) {
        // console.log(val, oldval)
      },
      $route (to, from) {
        // react to route changes...
        if (this.$route.params.type) {
          this.currentType = this.$route.params.type
          // console.log(this.$route.params.type)
        } else this.currentType = 'requests'
      },
    },
    created () {
      this.currentType = this.$route.params.type
      this.fetch(this.currentType)
    },
    beforeDestroy () {
      this.$store.dispatch('transactions/clearTransactions').then(function (res) {
        // console.log('transactions cleared')
      })
    },
    methods: {
      cancelRequest (item) {
        // console.log(item)
        const idOrden = item.idOrden
        const uid = item.client.id
        const ban = false
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: 'canceled',
          idUser: uid,
        }
        this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
          // console.log(res)
          this.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
          this.currentType = this.$route.params.type
          this.fetch(this.currentType)
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      changeStatus (item, event) {
        // console.log(item)
        const idOrden = item.idOrden
        const uid = item.client.id
        const ban = false
        const data = {
          banClientAdmin: ban,
          idOrder: idOrden,
          statusOrder: event,
          idUser: uid,
        }
        if (item.status !== 'cancel') {
          this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
            // console.log(res)
            this.setDataNotification(true, 'green', 'Se actualizó la orden de manera correcta.')
            this.currentType = this.$route.params.type
            this.fetch(this.currentType)
          })
        } else {
          this.$store.dispatch('transactions/updateStatusOrder', data).then((res) => {
            // console.log(res)
            this.setDataNotification(true, 'red', 'No se puede actualizar el estado de la orden ya que ha sido cancelado.')
          })
        }
      },
      showBill (item) {
        this.currentTransaction = item
        // console.log(item)
        this.showBillDialog = !this.showBillDialog
      },
      showSupportImage (url) {
        this.$swal({
          title: 'Comprobante',
          text: 'Modal with a custom image.',
          // imageUrl: url,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: 'Custom image',
          html: `
              <a target="_blank" href="${url}" download>
                <img style='max-height: 500px;' src="${url}" alt="comprobante">
              </a>
                    `,
          showConfirmButton: true,
        })
      },
      loadLog (type, dateFrom, dateTo) {
        const vm = this
        vm.$store.dispatch('transactions/loadLog', [type, dateFrom, dateTo, true]).then(function () {

        })
      },
      fetch (type = 'requests') {
        // vm.$store.commit('setLoading',true);
        const dateFrom = this.$moment().format('YYYY-MM-DD')
        this.loadLog(type, dateFrom, this.$moment(dateFrom).add(1, 'days').format('YYYY-MM-DD'))
      },
      clearShopSelection () {
        const vm = this
        vm.$store.dispatch('shops/setCurrentItem', null).then(function () {
        })
      },
      selectShop (item) {
        const vm = this
        // console.log(item)
        vm.$store.dispatch('shops/setCurrentItem', item).then(function () {
          // console.log(vm.$store.getters['shops/getCurrentItem'])
        })
      },
      setSearchCriteria (val) {
        const vm = this

        vm.$store.dispatch('transactions/setFilterCriteria', val).then(function () {
          //
        })
      },
      setFilterCriteria () {
        const vm = this

        this.$store.dispatch('transactions/setFilterCriteria', vm.select).then(function () {
          //
        })
      },

    },
  }
</script>
